'use strict';

const SV = require('server-vars');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const calloutHelper = require('../../../components/Callout/calloutHelper');
const calloutActions = require('../../../components/Callout/calloutActions');
const forceFavorite = require('../../../favorites/forceFavorite');

/**
 * Checks condition for follow search callout.
 * Opens callout if condition is satisfied.
 * Condition: "Save search" button is active and it is not thin page.
 *
 * @return {Promise}
 */
const followSearchCalloutRule = function followSearchCalloutRule({context}) {
    const {TYPE_SEARCH} = FavoriteModel;
    const type = calloutHelper.CALLOUT_TYPE_FOLLOW_SEARCH;
    const favoriteForced = forceFavorite.isTypeForced(forceFavorite.TYPE_SEARCH);
    const isSaveSearchButton = SV.get('data.saveSearch') === true;
    const thinPage = SV.get('data.thinPage');
    const canShowCallout = calloutHelper.canShowCallout({type});

    if (!canShowCallout || favoriteForced || !isSaveSearchButton || thinPage) {
        return Promise.resolve();
    }

    return calloutHelper
        .hasUserFavorites({type, context, favoriteType: TYPE_SEARCH})
        .then(hasFavorites => {
            if (!hasFavorites) {
                context.executeAction(calloutActions.openCallout, {type});
                return {success: true, type};
            }

            return {success: false, type};
        });
};

module.exports = followSearchCalloutRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/followSearchCalloutRule.es.js